export default class LoginForm {
    constructor() {
        return {
            template: require('../../../../views/login/organisms/o-login-form.html'),
            controller: LoginFormController,
            controllerAs: 'loginForm',
            bindings: {
                formFields: '=',
                isExternal: '<',
                enableReset: '&'
            }
        }
    }
}

class LoginFormController {
    constructor($scope, $element, $filter, $cookies, $window, User, TokenHandler, AccessHandler, LoginEvent, Translate, ResetHandler, CurrentAccount, Sogeti, $state) {
        this._scope = $scope;
        this._filter = $filter;
        this._translator = $filter('translate');
        this._cookies = $cookies;
        this._window = $window;

        this.translateService = Translate;
        this.userRepo = User;
        this.currentAccount = CurrentAccount;
        this.tokenHandler = TokenHandler;
        this.accessHandler = AccessHandler;
        this.loginHandler = LoginEvent;
        this.resetHandler = ResetHandler;
        this.sogeti = Sogeti;
        this._state = $state;
        this.errorText = null;
        this.imageMicrosoftSignIn = '/img/signinwithmicrosoft.svg';
        this.formFields = {
            email: null,
            password: null
        };

        this.$onInit = () => {
            $element.addClass('o-login-form');
            this.imageMicrosoftSignIn = this._filter('translate')('LOGIN:LOGIN-FORM:EXTERNAL:MICROSOFT_IMG');
        }

        this._scope.$on('event:login:success', (event, newSession) => {
            this.handleLoginSuccess(newSession);
        });
    };

    doLogin() {

        this.errorText = null;

        let email = this.formFields.email;
        let password = this.formFields.password;

        this.userRepo.logIn(email, password).then(
            this.handleLoginSuccess.bind(this),
            this.handleLoginError.bind(this),
        );
    };

    handleLoginSuccess(newSession) {
        this.formFields = {};
        this.tokenHandler.set(newSession.token);
        this.accessHandler.setRoles(newSession.roles);

        // We'll just use cookies for the notification token
        this._cookies.put('notification_token', newSession.notification_token);

        /* Clears user data in memory if it is another account */
        let currentAccountId = this.currentAccount.getData().account.id;
        if (currentAccountId && currentAccountId !== newSession.account_id) {
            return this._window.location.reload();
        }

        this.loginHandler.succeeded();

        if (newSession.language) {
            this.translateService.useLanguage(newSession.language.code)
        } else {
            this.translateService.setLanguage('sv').then(() => {
                this.translateService.useLanguage('sv');
            })
        }
        this._scope.$emit('event:beacon.reInit');

        if (this.sogeti.isSogetiAccount(newSession.account_id)) {
            this._state.go('event.index');
        }
    }

    handleLoginError() {
        this.errorText = this._filter('translate')('LOGIN:AUTH:ERROR');
    }
}

